import React from 'react'
import './TextTab.scss'

const TextTab = () => {
  return (
    <div>TextTab</div>
  )
}

export default TextTab